export default "__VITE_ASSET__4ec13838__"